
<template>
    <div>
        <pt-page-search @search="search" @emptySearch="emptySearch" :isAddrouter="false" :class="$style['select-form-user-search']" :searchKey="searchKey"></pt-page-search>
        <pt-page-factor-filter :labels="filterFactor" v-model="params" :class="$style['factor-style-select']">
            <el-button type="primary" plain @click="cutOrder" v-if="!isFilterOrder">切换至下单筛选</el-button>
            <el-button type="primary" plain @click="cutCustomer" v-if="isFilterOrder">切换至用户信息筛选</el-button>
            <el-button type="primary" @click="Filter">筛选</el-button>
        </pt-page-factor-filter>
        <div :class="$style['select-user-tip']">请使用筛选条件筛选并选择用户</div>
        <pt-select-list :tableData="tableData" :tableLabels="tableLabels"  @getTableData="getTableData" :total-count="totalCount" :loading="loading"
        :table-data="tableData" showName="firstName" @selected="selected" :selectedRows="selectRow" :pageSize="page_size" ref="selectList"
        isOutside></pt-select-list>
        <div class="button-div">
            <el-button type="primary" @click="submit" :loading="submitLoading">选择</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
    </div>
</template>
<script>
import ptSelectList from 'cps/base/pt-select-list'
import { couponUserListLabels, filterFactorUser, filterFactorUserOrder, filterFactorUserPromotion, companyUser, cityForUser } from './pt-all-customer/all-customer-option'
import { emptyObject } from '@/utils/lifebankUtils'

export default {
  components: {
    ptSelectList
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    selectedUser: {
      type: Array,
      default: function () {
        return []
      }
    },
    fromPage: {
      type: String,
      default: null
    },
    paramsOfDefault: {// 用户选择的默认筛选条件
      type: Object
    }
  },
  data () {
    return {
      tableData: [],
      tableLabels: couponUserListLabels,
      totalCount: 0,
      page_size: this.pageSize,
      selectRow: this.selectedUser,
      filterFactor: this.fromPage === 'promotion-form' ? filterFactorUserPromotion : filterFactorUser,
      params: this.paramsOfDefault || {},
      paramsData: this.paramsOfDefault || {},
      allCitys: [],
      sourceList: [],
      searchKey: null,
      loading: false,
      branchCompanys: [],
      submitLoading: false,
      isFilterOrder: false// 当前筛选条件是否是用户筛选
    }
  },
  watch: {
    'params.role' (val) {
      this.watchRole(val)
    }
  },
  methods: {
    // 角色变化，选框显示问题
    watchRole (val) {
      let hasComay = false
      let hasCity = false
      if (val && (val === 'COUNSELOR_USER' || val === 'DOCTOR_USER')) {
        this.filterFactor.forEach((item, index) => {
          if (item.value === 'branchCompanyId') {
            hasComay = true
          }
          if (item.value === 'city') {
            this.filterFactor.splice(index, 1)
            this.$set(this.params, 'city', null)
          }
        })
        if (!hasComay) {
          this.filterFactor.splice(1, 0, companyUser)
          this.getFilterLabelsOptions(this.branchCompanys, 'branchCompanyId')
        }
      } else {
        this.filterFactor.forEach((item, index) => {
          if (item.value === 'branchCompanyId') {
            this.filterFactor.splice(index, 1)
            this.$set(this.params, 'branchCompanyId', null)
          }
          if (item.value === 'city') {
            hasCity = true
          }
        })
        if (!hasCity) {
          this.filterFactor.splice(2, 0, cityForUser)
          this.getFilterLabelsOptions(this.allCitys, 'city')
        }
      }
    },
    // 获取分公司列表
    getBranchCompanyList () {
      let data = {
        pageableParam: {
          unpaged: true
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        this.branchCompanys = res.data
        this.getFilterLabelsOptions(res.data, 'branchCompanyId')
      }).catch(err => {
        this.$message.error(err || '获取分子公司列表失败')
      })
    },
    cutOrder () {
      this.isFilterOrder = true
      this.filterFactor = filterFactorUserOrder
    },
    cutCustomer () {
      this.isFilterOrder = false
      this.filterFactor = this.fromPage === 'promotion-form' ? filterFactorUserPromotion : filterFactorUser
    },
    search (val) {
      this.searchKey = val
      emptyObject(this.paramsData)
      emptyObject(this.params)
      this.$set(this.paramsData, 'searchKey', val)
      this.getTableData(0)
    },
    emptySearch () {
      this.$delete(this.paramsData, 'searchKey')
    },
    // 给筛选选项赋值
    getFilterLabelsOptions (val, name) {
      this.filterFactor.forEach(item => {
        if (item.value === name) {
          item.options = val
        }
      })
    },
    getAllCity () {
      this.$store.dispatch('getAllCity').then(res => {
        this.allCitys = res
        this.getFilterLabelsOptions(res, 'city')
      }).catch(err => {
        this.$message.error(err || '获取地区列表失败')
      })
    },
    businessSource () {
      this.$store.dispatch('businessSource').then(res => {
        this.sourceList = res
        this.getFilterLabelsOptions(res, 'channel')
      }).catch(err => {
        this.$message.error(err || '获取业务来源枚举失败')
      })
    },
    Filter () {
    //   if (this.params.gender) {
    //     this.paramsData.sex = this.params.gender ? Number(this.params.gender) : null
    //   }
      this.searchKey = null
      this.paramsData = { ...this.params }
      if (this.isFilterOrder) {
        for (var keyParams in this.paramsData) {
          filterFactorUser.forEach(item => {
            if (item.value === keyParams) {
              this.$delete(this.paramsData, keyParams)
            }
          })
        }
      } else {
        this.$delete(this.paramsData, 'mallOrder')
      }
      if (!this.isFilterOrder && this.params.age) {
        if (this.params.age.indexOf('-') > -1) {
          this.paramsData.ageStart = Number(this.params.age.split('-')[0])
          this.paramsData.ageEnd = Number(this.params.age.split('-')[1])
        } else if (this.params.age.indexOf('>') > -1) {
          this.paramsData.ageStart = Number(this.params.age.split('>')[1])
        }
        this.$delete(this.paramsData, 'age')
      }
      if (!this.isFilterOrder && this.params.loginTime) {
        this.paramsData = { ...this.params.loginTime, ...this.paramsData }
        this.$delete(this.paramsData, 'loginTime')
        this.$delete(this.params, 'index')
        this.$delete(this.paramsData, 'index')
        if (this.paramsData.age) {
          this.$delete(this.paramsData, 'age')
        }
      }
      if (this.isFilterOrder && this.params.goodsName) {
        this.paramsData.mallOrder = this.paramsData.mallOrder || {}
        this.paramsData.mallOrder.goodsName = this.params.goodsName
        this.$delete(this.paramsData, 'goodsName')
      }
      if (this.isFilterOrder && this.paramsData.mallOrder && this.paramsData.mallOrder.index) {
        let mallOrder = this.paramsData.mallOrder
        this.$delete(mallOrder, 'index')
      }
      if (this.paramsData.mallOrder && (this.paramsData.mallOrder.paidTimeStart || this.paramsData.mallOrder.paidTimeEnd)) {
        this.paramsData.mallOrder.paidTimeSort = 'ASC'
      }
      if (this.paramsData.bindCps) {
        this.paramsData.bindCps = this.paramsData.bindCps === 'true'
      }
      for (let key in this.paramsData) {
        if (!this.paramsData[key] && this.paramsData[key] !== false) {
          this.$delete(this.paramsData, key)
        }
      }

      //   this.getTableData(0)
      this.$refs.selectList.reset()
    },
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: page,
          size: this.page_size,
          sort: 'lastLoginTime,desc'
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getMallUser', data).then(res => {
        this.tableData = res.data
        this.totalCount = res.totalNumber
        this.loading = false
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.loading = false
        this.$refs.selectList.showReTry()
        this.$message.error(err || '获取用户列表失败')
      })
    },
    selected (val) {
      this.selectRow = val
    },
    submit () {
      if (this.fromPage === 'promotion-form') {
        if (!this.selectRow || !this.selectRow.length) {
          let data = {
            ...this.paramsData,
            pageable: {
              unpaged: true
            }
          }
          this.submitLoading = true
          this.$store.dispatch('getMallUser', data).then(res => {
            this.$emit('selectUsersSubmit', res.data)
            this.submitLoading = false
          }).catch(err => {
            this.$message(err || '查询已选择用户失败，请重新点击“选择”按钮提交')
          })
        } else {
          this.$emit('selectUsersSubmit', this.selectRow)
        }
      } else {
        this.$emit('selectUsersSubmit', this.selectRow)
      }
    },
    cancel () {
      this.$emit('close')
    },
    // 默认筛选登录时间为最近一个月
    getMounthLoginTime () {
      let nowDate = new Date().getTime()
      // 当前时间的一个月前的零点
      let startTime = new Date(new Date().toLocaleDateString()).getTime() - 30 * 24 * 3600 * 1000
      let loginTimeSelct = {
        lastLoginStartTime: startTime,
        lastLoginEndTime: nowDate
      }
      this.params = {
        loginTime: { ...loginTimeSelct }
      }
      this.paramsData = { ...loginTimeSelct }
    }
  },
  created () {
    this.getAllCity()
    this.getBranchCompanyList()
    this.businessSource()
    this.watchRole()
    // this.getMounthLoginTime()
  },
  destroyed () {
  }
}
</script>
<style module lang="less">
.select-user-tip{
  color: red
}
.select-form-user-search{
    max-width: 500Px;
    margin-bottom: 30px;
}
.factor-style-select{
  :global
  .branch-company-select{
    width: 275PX
  }
}
.filter-text{
    color: red;
    margin-bottom: 10px;
}
</style>
